export default __webpack_public_path__ + "static/media/bq.40b0aef3.svg";